<template>
  <v-container fluid>
    <v-row>
      <div class="header">
        <h2>Создание экземпляра растения</h2>
      </div>
      <div class="horizontal-rule"/>

      <h4 class="mt-1">
        Выберите тип растения, заполните все поля ниже, загрузите сканы, затем нажмите кнопку "отправить".
      </h4>

      <LoadingModal :is-loading="isLoading"/>

    </v-row>
    <v-row>
      <v-form
          id="exhibitCreationForm"
          style="width: 100vw"
          v-model="valid"
          lazy-validation
          ref="form"
      >

        <ExhibitInputs :exhibit-object="exhibitObject" @changePlantType="getPlantType"/>

        <v-row class="mt-1">
          <v-col>
            <UploadScans @pass="logData" :label-text="`Прикрепите сканы нажав сюда`" />
          </v-col>
          <v-col sm="4" v-if="exhibitObject.plantType === 'HIGHER_PLANT'">
            <UploadScans :rules="[true]" @pass="logLabelPhotos" :label-text="`Прикрепите фото этикетки нажав сюда`"/>
          </v-col>
          <v-col sm="4">
            <v-card tile elevation="3" class="pa-5 fill-height">
              <v-btn
                  width="40%"
                  class="rounded-0"
                  color="grey darken-1"
                  outlined
                  @click="sendExhibit"
              >
                отправить
              </v-btn>
              <v-btn
                  width="55%"
                  class="ms-1 rounded-0"
                  color="deep-orange darken-1"
                  outlined
                  @click="reset"
              >
                очистить форму
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-row>

  </v-container>
</template>

<script>
import UploadScans from "@/components/ExhibitCreationPageComponents/UploadScans";
import ExhibitInputs from "@/components/ExhibitCreationPageComponents/ExhibitInputs";
import LoadingModal from "@/components/UI/LoadingModal";
import {addExhibitLabelPhotos, addExhibitPhotos, createExhibitInfo, deleteExhibit} from "@/services/exhibitAPI";
import router from "@/router";

export default {
  name: "ExhibitCreationPage",
  components: {UploadScans, ExhibitInputs, LoadingModal},

  data() {
    return {
      valid: true,
      scans: [],
      labelPhotos: [],
      plantId: undefined,
      status: undefined,
      isLoading: false,

      exhibitObject: {
        barcode: '',
        family: '',
        genus: '',
        index: '',
        species: '',
        labelName: '',
        taxonomy: '',
        synonym: '',
        russianName: '',
        labelText: '',
        labelsCount: '',
        gps: {
          latitude: '',
          longitude: '',
        },
        collectionDate: {
          startDate: {
            day: '',
            month: '',
            year: ''
          },
          endDate: {
            day: '',
            month: '',
            year: ''
          },
        },
        photos: [],
        collectors: '',
        determinationDate: {
          startDate: {
            day: '',
            month: '',
            year: ''
          },
          endDate: {
            day: '',
            month: '',
            year: ''
          },
        },
        determinatedBy: '',
        natureConservationStatus: '',
        numberOfHerbariumSheets: '',
        gatheringPlaceCountry: '',
        gatheringPlaceRegion: '',
        gatheringPlaceDistrict: '',
        addedDate: Date.now(),
        submittedBy: '',
        ecologicalCharacteristics: '',
        note: '',
        plantType: 'HIGHER_PLANT',
        powotaxonomy: '',
      }
    }
  },

  methods: {

    async sendExhibit() {
      if (this.$refs.form.validate() && ((!this.exhibitObject.gps.latitude && !this.exhibitObject.gps.longitude) || (this.exhibitObject.gps.latitude && this.exhibitObject.gps.longitude))) {
        this.isLoading = true;
        console.log(this.exhibitObject);
        try {
          await createExhibitInfo(this.exhibitObject).then(data => this.plantId = data.result)
          try {
            for (const scan of this.scans) {
              await addExhibitPhotos(scan, this.plantId).then(data => console.log(data));
            }
            for (const scan of this.labelPhotos) {
              await addExhibitLabelPhotos(scan, this.plantId).then(data => console.log(data));
            }
            await router.push(`/collections`)
          }
          catch (e) {
            await deleteExhibit(this.plantId)
          }
        } catch (e) {
          console.log(e);
        }
        finally {
          this.isLoading = false;
        }
      }
    },

    getPlantType (type) {
      this.exhibitObject.plantType = type
    },

    logData(scans) {
      this.scans = scans;
    },

    logLabelPhotos(photos) {
      this.labelPhotos = photos
    },

    reset () {
      this.$refs.form.reset()
    },

  }
}
</script>

<style scoped>

</style>